import { Avatar } from '@fluentui/react-components';
import type { CSSProperties } from 'react';

// Ten distinct hues with enough contrast for white initials.
const PALETTE = ['#0f6cbd', '#c239b3', '#107c10', '#ca5010', '#8764b8', '#038387', '#c50f1f', '#986f0b', '#4f6bed', '#7a7574'];

function hash(value: string): number {
  let h = 0;
  for (const ch of value) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return h;
}

/** Position in the run's participant list decides the colour, so everyone sees the same unique colour per person. */
export function participantColor(participantIds: string[], userId: string): string {
  const index = participantIds.indexOf(userId);
  return PALETTE[(index >= 0 ? index : hash(userId)) % PALETTE.length];
}

export function UserAvatar({
  name,
  color,
  size,
  online,
  style,
}: {
  name: string;
  color: string;
  size: 16 | 20 | 24;
  online?: boolean;
  style?: CSSProperties;
}) {
  return (
    <Avatar
      size={size}
      name={name}
      badge={online ? { status: 'available' } : undefined}
      style={{ backgroundColor: color, color: '#fff', ...style }}
    />
  );
}
